import React from "react";
import {observer} from "mobx-react-lite";
import {Button, Checkbox, Form, FormField, Grid, Segment} from "semantic-ui-react";
import eventTesterStore from "./EventTesterStore";

function EventTester() {
    if (!eventTesterStore.visible) {
        return <></>
    }

    return <Grid>
        <Grid.Column width={'6'}>
            <Segment>
                <Form>
                    <FormField>
                        <label>StockTransferEventId</label>
                        <input value={eventTesterStore.stockTransferEventId}
                               onChange={e => eventTesterStore.setStockTransferEventId(e.target.value)}/>
                    </FormField>
                    <Button onClick={() => eventTesterStore.triggerStockTransferEventHandler()}
                            color={'teal'}>Trigger</Button>
                    <Checkbox label={'For Debug'} checked={eventTesterStore.forDebug}
                              onChange={(_, data) => eventTesterStore.changeForDebug(data.checked ?? false)}/>
                    <Button floated={'right'} onClick={() => eventTesterStore.hide()}>Close</Button>
                </Form>
            </Segment>
        </Grid.Column>
        <Grid.Column width={'6'}>
            <Segment>
                <Form>
                    <FormField>
                        <label>SkladEntityChangedEventId</label>
                        <input value={eventTesterStore.skladEntityChangedEventId}
                               onChange={e => eventTesterStore.setSkladEntityChangedEventId(e.target.value)}/>
                    </FormField>
                    <Button onClick={() => eventTesterStore.triggerSkladEntityChangedEventHandler()}
                            color={'teal'}>Trigger</Button>
                    <Checkbox label={'For Debug'} checked={eventTesterStore.forDebug}
                              onChange={(_, data) => eventTesterStore.changeForDebug(data.checked ?? false)}/>
                    <Button floated={'right'} onClick={() => eventTesterStore.hide()}>Close</Button>
                </Form>
            </Segment>
        </Grid.Column>
    </Grid>
}

export default observer(EventTester);